import type { AuthUser } from '../../services/auth';

interface UserIdentifierProps {
  user: AuthUser;
}

/** Shown in the top-right header so facilitators/admins know which account is signed in. */
export function UserIdentifier({ user }: UserIdentifierProps) {
  const label = user.email?.trim() || user.sub;
  const groups = user.groups?.length ? user.groups.join(', ') : undefined;

  return (
    <span
      title={groups ? `${label} (${groups})` : label}
      style={{
        fontSize: '13px',
        fontWeight: 500,
        opacity: 0.92,
        maxWidth: '240px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
